import { TAB_NAMES } from 'editor/src/store/editorModules/sidebar/types';
import type { HostSettingsState } from 'editor/src/store/hostSettings/types';

export interface Environment {
  production: boolean;
  env: EnvEnum;
  translationsUrl: string;
  // When true the app loads translations from the `lokalino/` subpath instead of the root. CI
  // publishes the same Lokalino bundle to both, so this only matters for local dev, which serves
  // translations from the root of the dev server.
  // Optional (defaults to false) so per-dev gitignored `properties/selected.ts` keeps compiling.
  useLokalino?: boolean;
  amplitudeKey: string;
  hostSettingsOverrides?: Partial<HostSettingsState>;
  enforceTabs?: TAB_NAMES[];
  shutterstockKeys: ShutterstockKeys;
  datadogClientToken: string;
}

export interface ShutterstockKeys {
  essentials: string;
  full: string;
}

export enum EnvEnum {
  dev = 'dev',
  test = 'test',
  staging = 'staging',
  live = 'live',
}
